import { render, staticRenderFns } from "./ziyingShop.vue?vue&type=template&id=73acc90a&scoped=true&"
import script from "./ziyingShop.vue?vue&type=script&lang=ts&"
export * from "./ziyingShop.vue?vue&type=script&lang=ts&"
import style0 from "./ziyingShop.vue?vue&type=style&index=0&id=73acc90a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73acc90a",
  null
  
)

export default component.exports